import { BaseService } from "./BaseService";
import { BulkUpdateTasksDto, Task, UpdateTaskDto } from "@/types/tasks";
import { ITasksService } from "./interfaces/ITasksService";

class TasksService extends BaseService implements ITasksService {
  private basePath = "/tasks";

  constructor() {
    super();
  }

  async update(id: string, data: UpdateTaskDto): Promise<Task> {
    return this.patch<Task>(`${this.basePath}/${id}`, data);
  }

  async bulkUpdate(data: Partial<BulkUpdateTasksDto>): Promise<Task[]> {
    return this.put<Task[]>(`${this.basePath}/bulk`, data);
  }
}

export const tasksService = new TasksService();
